import React, { useEffect, useState } from "react";
import { Create, SimpleForm, TextInput, required, DateInput, AutocompleteInput, useRedirect, useNotify, FileInput, FileField } from "react-admin";
import { useLocation } from "react-router-dom";
import { getNameAndCompanyNamewithAddress } from "../common";

const EstimateHistoryCreate = () => {
  const [customers,setCustomers]=useState([]);
  const redirect = useRedirect();
  const notify = useNotify();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [customerId,setCustomerId]=useState(searchParams.get("customer"));

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  return (
    <>
    {customers &&
      <Create mutationMode="pessimistic"
        mutationOptions={{ 
          onSuccess: () => {
            notify('作成が完了しました', { type: 'success' }); 
            // redirect('list', 'estimateHistory');
            window.history.back();
          }
        }}
      >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
          <AutocompleteInput
            source="customerId"
            label="顧客名"
            choices={customers.map(req => ({
              id: req.id, 
              name: `${getNameAndCompanyNamewithAddress(req)}`
            }))}
            onChange={(e) => setCustomerId(e)}
            defaultValue={customerId}
            validate={required()}
            allowEmpty
            freeSolo  
          />
          <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
            <DateInput source="createEstimateDate" label="見積作成日" style={{marginRight:"10px"}} inputProps={{ max: '9999-12-31' }}/>
            <DateInput source="requestEstimateDate" label="見積依頼日" style={{marginLeft:"10px"}} inputProps={{ max: '9999-12-31' }}/>
          </div>
          <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
            <TextInput source="estimateAmount" label="見積金額(税抜き)" style={{marginRight:"10px"}}/>
            <TextInput source="createrName" label="見積作成者"　style={{marginLeft:"10px"}}/>
          </div>
          <FileInput source="documentURL" label="見積書" accept="application/pdf, image/*">
            <FileField source="src" title="title" />
          </FileInput>
        </SimpleForm>
      </Create>
    }
    </>
  )

};

export default EstimateHistoryCreate;
